import { MessagingTemplateTypes } from "@enums/messaging-template-types";

export const initialMessagingTemplatePerType: { [key in MessagingTemplateTypes]: Array<any> } = {
    [MessagingTemplateTypes.PIN_EMAIL]: [],
    [MessagingTemplateTypes.PIN_SMS]: [],
    [MessagingTemplateTypes.DCUI_EMAIL]: [],
    [MessagingTemplateTypes.DCUI_SMS]: []
} 